import { TAX_CONTACT_TYPE } from "./actionTypes";

const INIT_STATE = {
  taxContactType: "MAIN_MANAGER",
};

const TaxPortal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TAX_CONTACT_TYPE:
      return {
        ...state,
        taxContactType: action.payload
      };
    default:
      return state;
  }
};

export default TaxPortal;
